module.exports = __webpack_public_path__ + "static/img/2_5.4010a424.jpg";